import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, withLatestFrom } from 'rxjs/operators';
import { RxTemplate } from '@shared/rx-templates/rx-template.model';
import { ProcedureMap } from '@shared/models/procedure-map';
import { ISectionDirtyCheckService } from '@shared/models/section-dirty-check';
import { ApplianceDetailsQuery } from '@modules/appliance-details/state/appliance-details.query';
import { ApplianceDetailsDirtyCheckService } from '@modules/appliance-details/appliance-details-dirty-check.service';
import { OrderQuery } from '@modules/order/state/order-query';
import { RxIntuitiveApplianceVisibilityService } from './rx-intuitive-appliance-visibility.service';

@Injectable({ providedIn: 'root' })
export class RxIntuitiveApplianceDirtyCheckService implements ISectionDirtyCheckService {
	constructor(
		private readonly query: ApplianceDetailsQuery,
		private readonly orderQuery: OrderQuery,
		private readonly visibilityService: RxIntuitiveApplianceVisibilityService
	) {}

	willLoseDataFor$(targetTemplate: Readonly<RxTemplate>, targetProcedureMap: ProcedureMap | null): Observable<boolean> {
		return this.visibilityService.fieldsFor$(targetTemplate, targetProcedureMap).pipe(
			withLatestFrom(this.visibilityService.fields$, this.visibilityService.isSectionVisible$),
			map(([tgt, cur, isVisible]) => {
				if (!isVisible) {
					return false;
				}

				const s = this.query.getValue();

				return (
					(cur.procedureType && !tgt.procedureType && this.orderQuery.hasProcedureTypeId) ||
					(cur.applianceType && !tgt.applianceType && ApplianceDetailsDirtyCheckService.hasApplianceType(s)) ||
					(cur.upperLowerCard && !tgt.upperLowerCard && ApplianceDetailsDirtyCheckService.hasUpperLower(s))
				);
			})
		);
	}
}
